import axiosInstance from "../../../api/axiosInstance";

export let getSpaces = async (props) => {
    try {
        const response = await axiosInstance.get(process.env.REACT_APP_API + "/espacios/get/all/" + props?.profile + "/" + props?.locale);

        switch (props?.profile) {
            case "Regional User":
                const countries = response.data.respuesta.filter(element => props.locale.includes(element.Pais.Nombre));
                return {
                    status: response.status,
                    data: { respuesta: countries }
                };

            case "Country User":
            case "Reading User":
                const databyrolecountry = response.data.respuesta.filter(element => props.locale[0] === element.Pais.Nombre);        
                return {
                    status: response.status,
                    data: { respuesta: databyrolecountry }
                };

            case "Admin":
            case "Corporate User":
                return response;

            default:
                return undefined;
        }
    } catch (error) {
        return error.response;
    }
};

// export let getSpacesById = async(id, user) => {
//     return new Promise((resolve, reject) => {   
    
//         axiosInstance.get(process.env.REACT_APP_API + "/" + id + "/" + user?.profile + "/" + user?.locale).then(response=> {
//             resolve(response);
//         }).catch(error => {
//             resolve(error.response);
//         });
//     })
// }

export let getFiltersByCountryId = async(id, user) => {
    return new Promise((resolve, reject) => {   
    
        axiosInstance.get(process.env.REACT_APP_API + "/espacios/desplegables/" + id + "/" + user?.profile + "/" + user?.locale).then(response=> {
            resolve(response);
        }).catch(error => {
            resolve(error.response);
        });
    })
}

export let getSpaceByFilter = async (prop, user) => {
    if (!prop) return;

    const locations = prop.locations || null;
    const name = prop.modulename || null;
    const code = prop.code || null;
    const country = prop.country || null;

    const uri = `${process.env.REACT_APP_API + "/espacios/filtro/"}${locations}/${name}/${code}/${country}/${user?.profile}/${user?.locale}`;

    try {
        const response = await axiosInstance.get(uri);

        switch (user?.profile) {
            case "Regional User":
                const countries = response.data.respuesta.filter(element => user.locale.includes(element.Pais.Nombre));

                return {
                    status: response.status,
                    data: { respuesta: countries }
                };

            case "Country User":
            case "Reading User":
                const databyrolecountry = response.data.respuesta.filter(element => user?.locale[0] === element.Pais.Nombre);

                return {
                    status: response.status,
                    data: { respuesta: databyrolecountry }
                };

            case "Admin":
            case "Corporate User":
                return response;

            default:
                return undefined;
        }
    } catch (error) {
        return error.response;
    }
};
